module.exports = __webpack_public_path__ + "img/post3.4ece986b.jpg";